import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=4f268064"
import script from "./ItemTable.vue?vue&type=script&lang=js"
export * from "./ItemTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports